import * as React from 'react';
import classNames from 'classnames';
import styles from './Overlay.module.scss';

type Props = {
    show: boolean;
};

const Overlay = ({ show }: Props) => {
    const className = show ? classNames(styles.overlay, styles.show) : styles.overlay;
    return show && <div className={className} />;
};

Overlay.defaultProps = {
    show: false,
};

export default React.memo<Props>(Overlay);
